<template>
  <div>
    <div class="container main">
      <div>
        <div class="preview"></div>
      </div>
      <div class="upload-list">
        <div style="font-size: 18px; line-height: 2.225; color: #666; display:flex; align-items:center; width: 375px;">
          <div style="flex: 1;">
            上传轮播图
            <i :style="{ display: syncing ? '' : 'none' }" class="el-icon-loading"></i>
          </div>
          <el-upload v-if="list.length < 5" :show-file-list="false" :on-change="addImage" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
          </el-upload>
        </div>
        <p style="font-size: 12px; color: #ccc;">最多上传5张图片，最佳比例3:1</p>
        <div class="upload-item" v-for="(item, index) in list" :key="item">
          <div class="upload-item-image" :style="{ 'background-image': `url(${item.image})` }">
            <div class="upload-item-image-cover">
              <span v-if="!item.product" @click="editRow(item)">
                <i class="el-icon-warning" style="margin-right: 4px; color: rgb(206, 55, 46);"></i>
                暂未配置跳转，点击进行配置
              </span>
              <span v-if="item.product" @click="editRow(item)">
                <i class="el-icon-success" style="margin-right: 4px; color: rgb(104, 153, 110);"></i>
                商品 {{ item.product.name }}
              </span>
            </div>
          </div>
          <div class="upload-item-op">
            <el-tooltip effect="dark" content="删除该图片" placement="right">
              <i class="el-icon-close" v-on:click="deleteRow(item)" />
            </el-tooltip>
            <el-tooltip effect="dark" content="置顶图片" placement="right">
              <i v-if="index !== 0" class="el-icon-caret-top" v-on:click="updateRowTopTime(item)" />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="设置跳转结果" :visible.sync="showDialog" width="30%" :before-close="handleClose">
      <div class="banner-dialog">
        <div class="banner-dialog-radio-group">
          <el-radio v-model="row.linkprefix" label="product://">商品</el-radio>
        </div>
        <div class="banner-dialog-comment" v-if="row.linkprefix == 'product://'">请输入商品名后选择添加</div>
        <div v-if="row.linkprefix == 'product://'">
          <el-row gutter="8">
            <el-col span="16">
              <el-select size="small" remote filterable :loading="fetchProductLoading" :remote-method="getProducts" placeholder="搜索商品" v-model="row.link" style="width: 100%;">
                <el-option :key="product.id" :label="product.name" :value="product.id" v-for="product in products"></el-option>
              </el-select>
            </el-col>
            <el-col span="2">
              <el-button size="small" @click="updateRowLink" type="primary">确认</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { M } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken, sortObject } from '../../../service/helper.js';
import config from '../../../../config.js';
export default {
  name: 'Banner',
  data() {
    return {
      row: {},
      showDialog: false,
      token: getToken(),
      syncing: false,
      products: [],
      list: []
    };
  },
  async mounted() {
    const res = await rpc('StoreSlideShowService.GetSlideShowList', M('SlideShowListQueryRequest', { token: M('Token', { token: this.token }), count: 100 }));

    const productidlist = res.slideshowlistList.filter(v => v.link.startsWith('product://')).map(v => v.link.slice(10));
    const res1 = await rpc(
      'StoreProductService.GetProductList',
      M('ProductListQueryRequest', {
        token: M('Token', { token: this.token }),
        idlistList: productidlist,
        count: productidlist.length,
        sortby: 1,
        sort: 1
      })
    );
    res.slideshowlistList.forEach(item => (item.product = res1.productlistList.find(v => v.id == item.link.slice(10))));

    this.list = res.slideshowlistList;
  },

  methods: {
    async addImage(f) {
      const reader = new FileReader();
      const file = f.raw;
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      const upl = async () => {
        if (!isJpgOrPng) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!');
          return;
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
          return;
        }

        this.syncing = true;

        const formData = new FormData();

        formData.append('file', file);

        const image = await fetch('https://'+config.domain+'/up', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        })
          .then(response => response.json())
          .then(data => `${data.file}`);

        const row = await rpc(
          'StoreSlideShowService.CreateSlideShow',
          M('SlideShowWithTokenRequest', {
            token: M('Token', { token: this.token }),
            slideshow: M('SlideShow', {
              image,
              toptime: parseInt(Date.now() / 1000)
            })
          })
        );
        this.list.splice(0, 0, row);
        this.syncing = false;
      };

      reader.onload = evt => {
        const image = new Image();
        image.onload = () => {
          const { width, height } = image;

          upl();
        };
        image.src = evt.target.result;
      };

      reader.readAsDataURL(file);
    },

    editRow(row) {
      row = JSON.parse(JSON.stringify(row));
      row.linkprefix = '';
      if (row.link.startsWith('product://')) {
        row.linkprefix = 'product://';
        row.link = row.link.slice(10);
      }
      if (row.linkprefix == '') {
        row.link = '';
      }
      this.row = row;
      this.showDialog = true;
    },

    async deleteRow(row) {
      await rpc(
        'StoreSlideShowService.DeleteSlideShow',
        M('IDWithTokenRequest', {
          token: M('Token', { token: this.token }),
          id: row.id
        })
      );
      this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
    },

    async updateRowTopTime(row) {
      row = JSON.parse(JSON.stringify(row));
      const res = await rpc(
        'StoreSlideShowService.UpdateSlideShow',
        M('SlideShowWithTokenRequest', {
          token: M('Token', { token: this.token }),
          slideshow: M('SlideShow', {
            ...row,
            toptime: parseInt(Date.now() / 1000)
          })
        })
      );
      res.product = row.product;
      this.list.splice(this.list.findIndex(v => v.id === row.id), 1);
      this.list.splice(0, 0, res);
    },
    async updateRowLink() {
      if (!this.row.linkprefix || !this.row.link) {
        this.showDialog = false;
        return;
      }
      const row = JSON.parse(JSON.stringify(this.row));
      const res = await rpc(
        'StoreSlideShowService.UpdateSlideShow',
        M('SlideShowWithTokenRequest', {
          token: M('Token', { token: this.token }),
          slideshow: M('SlideShow', {
            ...row,
            link: row.linkprefix + row.link
          })
        })
      );
      if (res.link.startsWith('product://')) {
        res.product = await rpc(
          'StoreProductService.GetProduct',
          M('IDWithTokenRequest', {
            token: M('Token', { token: this.token }),
            id: res.link.slice(10)
          })
        );
      }
      this.list.splice(this.list.findIndex(v => v.id === row.id), 1, res);
      this.showDialog = false;
    },
    getProducts(name) {
      if (!name) return (this.products = []);
      this.fetchProductLoading = true;
      rpc1(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: this.token }),
          name,
          isonline: 1,
          sortby: 1,
          sort: 1,
          count: 100
        })
      ).then(res => {
        this.products = res.productlistList;
        this.fetchProductLoading = false;
      });
    }
  }
};
</script>

<style scoped>
.main {
  display: flex;
  padding: 48px;
}
.main > div {
  flex: 1;
}
.main > div.upload-list {
  flex: 1.5;
}

.preview {
  background: url(../../../assets/images/banner-preview.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 45.9vh;
  height: 78.3vh;
}
.upload-item {
  width: 375px;
  height: 140px;
  margin: 24px 0;
  position: relative;
  border: 1px solid #cdcdcd;
}
.upload-item-image {
  background-color: #efefef;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  position: relative;
}
.upload-item-image-cover {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: rgb(230, 230, 230);
  background-color: rgba(0, 0, 0, 0.8);
  height: 24px;
  display: flex;
  align-items: center;
  padding-left: 8px;
  cursor: pointer;
}
.upload-item-op {
  position: absolute;
  cursor: pointer;
  font-size: 18px;
  width: 32px;
  line-height: 32px;
  right: -48px;
  top: 0;
  bottom: 0;
}

.banner-dialog-radio-group {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.banner-dialog-radio-group .el-radio {
  margin-top: 8px;
  margin-left: 0;
  margin-right: 15px;
}
.banner-dialog-comment {
  margin-top: 25px;
  margin-bottom: 5px;
  font-size: 12px;
  color: #999;
}
</style>
